// Shared Tailwind override for MUI outlined controls used as dashboard filters
// (Select dropdowns + date pickers). Locks the whole control to a crisp 48px box:
// pins the notchedOutline fieldset to the input height (removes the "ghost" double
// border), whitens the surface, and normalizes the border to the theme divider.
export const FILTER_CONTROL =
  "[&_.ml-4]:!hidden " +
  "[&_.MuiInputBase-root]:!h-[48px] [&_.MuiInputBase-root]:!min-h-[48px] " +
  "[&_.MuiInputBase-root]:!bg-surface [&_.MuiInputBase-root]:!rounded-lg " +
  "[&_.MuiSelect-select]:!py-0 [&_.MuiSelect-select]:!min-h-0 " +
  "[&_.MuiOutlinedInput-input]:!py-0 " +
  "[&_fieldset]:!top-0 [&_fieldset]:!h-full [&_fieldset]:!rounded-lg [&_fieldset]:!border-divider " +
  "[&_legend]:!hidden"
